import styled from "styled-components";

const DjzSignupPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;
  min-height: 100vh;
  color: white;

  .formsLayout {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    padding: 0 16px 32px;
    box-sizing: border-box;
  }

  .formsLayoutjawal {
    min-height: 100vh;
  }

  .header_gamezone {
    margin-top: 5px !important;
    width: 100%;
    border-bottom: none;
  }

  .gamezoneLogo {
    max-width: 163px !important;
  }

  .header {
    margin-top: 24px;
    margin-bottom: 8px;

    .logo {
      background: var(--navbarLogo) center center no-repeat;
      height: var(--loginLogoHeight);
      width: var(--loginLogoWidth);
      max-width: 350px;
      background-size: var(--background-size);
      margin: 0 auto;
    }
  }

  .djz-lang-select {
    padding: 4px 8px;
    border-radius: 10px;
    border: none;
    background: rgba(0, 0, 0, 0.25);
    color: white;
    outline: none;
    box-shadow: none;
  }

  .links-Section {
    position: static;
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .links-Sectionjawwalgamezorid {
    top: auto !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .play {
      background: var(--games_icon) center center no-repeat;
      width: 100%;
      max-width: 360px;
      height: 220px;
      margin: 0 auto 16px;
      background-size: contain !important;
    }
  }

  .djz-form-wrap {
    width: 100%;
    max-width: 340px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .gamezoneInput {
    background: white;
    color: black;
    padding: 10px 12px;
    border: none;
    outline: none;
    box-shadow: none;
    border-radius: 8px;
    font-size: 1rem;
    box-sizing: border-box;
  }

  .gamezoneInput:focus {
    outline: none;
    box-shadow: none;
  }

  .djz-package-select {
    width: 100%;
    text-align: center;
  }

  .djz-verify-section {
    width: 100%;
    text-align: center;

    p {
      font-size: 14px;
      margin: 0 0 12px;
      line-height: 1.35;
    }
  }

  .djz-otp-input {
    width: 100%;
    text-align: center;
  }

  .djz-phone-row {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 6px;
    direction: ltr;
  }

  .gamezonekeyph {
    width: 72px;
    flex: 0 0 72px;
    text-align: center;
    float: none;
    margin: 0;
  }

  .gamezonenumph {
    flex: 1;
    min-width: 0;
    text-align: left;
    float: none;
    margin: 0;
  }

  .djz-subscribe-btn {
    width: 100%;
    max-width: 340px;
    min-width: 0;
    margin: 8px auto 0;
    padding: 14px 32px;
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    cursor: pointer;
    border: none;
    outline: none;
    border-radius: 999px;
    color: #fff;
    background: linear-gradient(135deg, #8b3fd6 0%, #65378b 55%, #4a2468 100%);
    box-shadow: 0 8px 24px rgba(74, 36, 104, 0.45);
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  }

  .djz-subscribe-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(74, 36, 104, 0.55);
  }

  .djz-subscribe-btn:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 6px 16px rgba(74, 36, 104, 0.4);
  }

  .djz-subscribe-btn:focus {
    outline: none;
    box-shadow: 0 8px 24px rgba(74, 36, 104, 0.45);
  }

  .djz-subscribe-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  .footer {
    width: 100%;
    max-width: 420px;
    margin: 24px auto 0;
    text-align: center;
  }

  .ncellTos {
    font-size: 13px;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .ncellTos p {
    line-height: 1.35;
    margin: 0 0 8px;
    max-width: 100%;
  }

  .zainiqFooter p {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    .links-Sectionjawwalgamezorid .play {
      height: 180px;
    }

    .gamezonekeyph {
      width: 64px;
      flex-basis: 64px;
    }
  }
`;

export default DjzSignupPageDisplay;
